// JsFromRoutes CacheKey 3b21f7fc8c94f663f596ae55286ce72c
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  show: /* #__PURE__ */ definePathHelper('get', '/:org_nano_id/content'),
}
